import "../../../css/app.css";
import AddCardForm from "./element-controllers/AddCardForm.js";
import AppSidebar from "./element-controllers/AppSidebar.js";
import AutoGrowTextarea from "./element-controllers/AutoGrowTextarea.js";
import ChatwootReset from "./element-controllers/ChatwootReset.js";
import ClipboardText from "./element-controllers/ClipboardText.js";
import DeliveryPlanningMap from "./element-controllers/DeliveryPlanningMap.js";
import PickListSelection from "./element-controllers/PickListSelection.js";
import LibrarySelection from "./element-controllers/LibrarySelection.js";
import LibraryPhoto, { LibraryPhotoFilter, LibrarySearchStatus } from "./element-controllers/LibraryPhoto.js";
import InventoryPhotoHandoff from "./element-controllers/InventoryPhotoHandoff.js";
import PhotoSuggestions from "./element-controllers/PhotoSuggestions.js";
import OrganizationLogoInput from "./element-controllers/OrganizationLogoInput.js";
import OrganizationMailPreview from "./element-controllers/OrganizationMailPreview.js";
import PlaceMap from "./element-controllers/PlaceMap.js";
import PullToRefresh from "./element-controllers/PullToRefresh.js";
import ScrollToHash from "./element-controllers/ScrollToHash.js";
import SumInputs from "./element-controllers/SumInputs.js";
import SyncImage from "./element-controllers/SyncImage.js";
import TermsAcceptance from "./element-controllers/TermsAcceptance.js";
import { initializeGlobal } from "./global.js";
import BrowserNotifications from "./global-controllers/BrowserNotifications.js";
import FeatureCheck from "./global-controllers/FeatureCheck.js";
import ImageUpdater from "./global-controllers/ImageUpdater.js";
import FurnitureUpdates from "./global-controllers/FurnitureUpdates.js";
import TurboDrive from "./global-controllers/turbo/TurboDrive.js";
import { registerSWAndSendInitialMessages } from "./utils/sw.js";
const _ev = initializeGlobal([
    TurboDrive,
    BrowserNotifications,
    FeatureCheck,
    SyncImage,
    ImageUpdater,
    FurnitureUpdates,
    AddCardForm,
    ChatwootReset,
    ClipboardText,
    DeliveryPlanningMap,
    PlaceMap,
    PickListSelection,
    LibrarySelection,
    LibraryPhoto,
    LibraryPhotoFilter,
    LibrarySearchStatus,
    InventoryPhotoHandoff,
    PhotoSuggestions,
    OrganizationLogoInput,
    OrganizationMailPreview,
    AppSidebar,
    AutoGrowTextarea,
    PullToRefresh,
    ScrollToHash,
    SumInputs,
    TermsAcceptance,
]);
// SW --------------------------------------------------------------------------
if ("serviceWorker" in navigator) {
    registerSWAndSendInitialMessages();
}
//# sourceMappingURL=app.js.map